// Verified from YK Motors' AutoTrader profile & adverts (snapshot 22 Oct 2026). Edit here to update the whole site.
const AT_PROFILE = "https://www.autotrader.co.uk/dealers/northamptonshire/peterborough/yk-motors-10018055?channel=cars";

export const DEALER = {
  name: "YK Motors",
  address: { line1: "Muse House", town: "Peterborough", postcode: "PE1 5YD" },
  phone: { display: "07537 125447", href: "tel:+447537125447" },
  email: "yk.motors@outlook.com",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=52.5819466%2C-0.2062245",
  mapEmbed:
    "https://www.openstreetmap.org/export/embed.html?bbox=-0.2152%2C52.5786%2C-0.1972%2C52.5853&layer=mapnik&marker=52.5819466%2C-0.2062245",
  hours: [
    { day: "Monday", hours: "09:00 – 18:00" },
    { day: "Tuesday", hours: "09:00 – 18:00" },
    { day: "Wednesday", hours: "09:00 – 18:00" },
    { day: "Thursday", hours: "09:00 – 18:00" },
    { day: "Friday", hours: "09:00 – 18:00" },
    { day: "Saturday", hours: "09:00 – 18:00" },
    { day: "Sunday", hours: "09:00 – 17:00" },
  ],
  viewingNote: "Viewings by appointment only — happy to book around your working hours.",
  rating: { score: "5.0", reviews: 126, checked: "22 October 2026" },
  awards: ["2024", "2025", "2026"],
  autotrader: {
    profile: AT_PROFILE,
    reviews: `${AT_PROFILE}#reviews`,
    stock:
      "https://www.autotrader.co.uk/cars/retailer/stock?advertising_location=at_cars&postcode=st15%208dh&retailerId=10018055&sort=price-asc",
  },
};

export const SERVICES = [
  {
    key: "sourced",
    title: "Privately sourced, properly checked",
    text: "We privately source our cars, and each one is quality checked by our staff as well as qualified mechanics.",
  },
  {
    key: "warranty",
    title: "Warranty with most vehicles",
    text: "A free Gold cover warranty comes with most vehicles, with the option to extend it if you wish.",
  },
  {
    key: "finance",
    title: "Finance & part exchange",
    text: "Part exchange is available. If you'd like to arrange finance, call us and we'll talk it through.",
  },
  {
    key: "video",
    title: "Live video viewings",
    text: "Can't get here yet? We'll give you a live FaceTime or WhatsApp tour of the car — inside, outside and an engine start.",
  },
  {
    key: "delivery",
    title: "Click & collect or delivery",
    text: "Reserve and collect, or ask about our delivery service.",
  },
  {
    key: "hours",
    title: "Open 7 days, by appointment",
    text: "Viewings are by appointment, and we're happy to book around your working hours.",
  },
];
